class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    // Trigger is now a real link (navigates); the submenu lives in .mega-menu.
    this.trigger = this.querySelector('a[aria-haspopup]') || this.querySelector('a');
    this.content = this.querySelector('.mega-menu');

    // Open on keyboard focus, or when hovering the trigger LINK. Hover is bound
    // to the link only (not the whole element) so the full-width submenu panel
    // — which is position:absolute and sits over the banner area when closed —
    // can never open the menu just by moving the cursor across the banner.
    // Close when focus leaves the element, the mouse leaves it, or Escape.
    this.addEventListener('focusin', this.open.bind(this));
    if (this.trigger) this.trigger.addEventListener('mouseenter', this.open.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('mouseleave', this.close.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  open() {
    if (!this.content || this.content.hasAttribute('open')) return;
    this.content.setAttribute('open', '');
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
    if (this.header) {
      this.header.preventHide = true;
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }
  }

  close() {
    if (!this.content) return;
    this.content.removeAttribute('open');
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    if (this.header) this.header.preventHide = false;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyDown(event) {
    if (event.key !== 'Escape') return;
    this.close();
    if (this.trigger) this.trigger.focus();
  }
}

customElements.define('header-menu', HeaderMenu);
